import "../../css/Content.css";
import UserMenuId from "../../utils/constants/UserMenuId";
import TablePage from "../table/TablePage";
import MyInfoPage from "./MyInfoPage";
import LessonHistoryPage from "./LessonHistoryPage";
import PaymentHistoryPage from './PaymentHistoryPage';

let UserContent = (props) => {
    switch (props.currentMenu) {
        case UserMenuId.TABLE:
            return <TablePage
                data={props.data}
                location={props.location} isAdmin={false}
                myInformation={props.myInformation}
                setNeedInfoRefresh={props.setNeedInfoRefresh}
            ></TablePage>;
        case UserMenuId.MY_INFO:
            return <MyInfoPage
                data={props.data}
                location={props.location} myInformation={props.myInformation}
                setNeedInfoRefresh={props.setNeedInfoRefresh}
            />
        case UserMenuId.LESSON_HISTORY:
            return <LessonHistoryPage data={props.data} location={props.location}
                setNeedInfoRefresh={props.setNeedInfoRefresh}
            />
        case UserMenuId.PAYMENT_HISTORY:
            return <PaymentHistoryPage setNeedInfoRefresh={props.setNeedInfoRefresh} />
        default:
            return null;
    }
}
export default UserContent
